/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import './IntradayRefreshLabel.scss';
import React from 'react';
import { connect } from 'react-redux';
import { getIntradayRefreshStatus } from 'state/account/AccountSelectors';
import { intradayRefreshEnabled } from '../../../services/FeatureFlags';

const IntradayRefreshLabel = ({ status }) => {
  const { isPending, isAfterHours } = status;
  return intradayRefreshEnabled() && !isAfterHours ? (
    <span className="intraday-refresh-timestamp">
      {isPending && <span>Refreshing ...</span>}
    </span>
  ) : null;
};

const mapStateToProps = (state) => ({
  status: getIntradayRefreshStatus(state)
});

export default connect(mapStateToProps)(IntradayRefreshLabel);
